module.exports = __webpack_public_path__ + "img/xxxx.7a8bd78c.svg";